var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8477 20.468C22.5703 18.6469 23.625 16.2 23.625 13.5C23.625 7.91016 19.0898 3.375 13.5 3.375C7.91016 3.375 3.375 7.91016 3.375 13.5C3.375 16.2 4.42969 18.6469 6.15234 20.468C7.65 22.043 9.30937 24.2648 9.9 27H17.1C17.6906 24.2578 19.35 22.043 20.8477 20.468ZM23.2945 22.7883C21.6352 24.5391 20.25 26.6766 20.25 29.0883V30.375C20.25 33.4828 17.7328 36 14.625 36H12.375C9.26719 36 6.75 33.4828 6.75 30.375V29.0883C6.75 26.6766 5.36484 24.5391 3.70547 22.7883C1.40625 20.3695 0 17.1 0 13.5C0 6.04688 6.04688 0 13.5 0C20.9531 0 27 6.04688 27 13.5C27 17.1 25.5938 20.3695 23.2945 22.7883ZM10.125 12.9375C10.125 13.8727 9.37266 14.625 8.4375 14.625C7.50234 14.625 6.75 13.8727 6.75 12.9375C6.75 9.52031 9.52031 6.75 12.9375 6.75C13.8727 6.75 14.625 7.50234 14.625 8.4375C14.625 9.37266 13.8727 10.125 12.9375 10.125C11.3836 10.125 10.125 11.3836 10.125 12.9375Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbIcon);
export default __webpack_public_path__ + "static/media/light-bulb-icon.5e024a8e30673640b31599deea9ca518.svg";
export { ForwardRef as ReactComponent };